export const LISTINGS_DEBOUNCE_FETCH_MS = 420;
